import BaInfoConstants from 'Shared/constants/BaInfo.constants';
import * as PiIntegrationsAPI from '../api/PiIntegrations.api';
import { AxiosResponse } from 'axios';

export const getBaInfoSuccess = payload => ({
  type: BaInfoConstants.Actions.GET_BA_INFO_SUCCESS,
  payload,
});

export const getUser =
  ({ companyGuid, userGuid }: { companyGuid: string; userGuid: string }) =>
  dispatch => {
    return PiIntegrationsAPI.getUser({ companyGuid, userGuid })
      .then((response: AxiosResponse) => {
        dispatch(getBaInfoSuccess({ ...response.data, userGuid }));
        return response;
      })
      .catch(error => {
        return error.response;
      });
  };

export const createBaSuccess = payload => ({
  type: BaInfoConstants.Actions.CREATE_BA_SUCCESS,
  payload,
});

export const createBehavioralAssessment =
  ({ companyGuid, payload, userGuid }: { companyGuid: string; payload: any; userGuid: string }) =>
  dispatch => {
    return PiIntegrationsAPI.createBehavioralAssessment({ companyGuid: companyGuid, payload: payload })
      .then((response: AxiosResponse) => {
        dispatch(createBaSuccess({ assessmentId: response.data.assessmentId, userGuid }));
        return response;
      })
      .catch(error => {
        return error.response;
      });
  };
